import Box from "@mui/material/Box";
import SoftButton from "components/SoftButton";
import { styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { THEME_COLORS } from "constants/theme";

const ButtonsWrapper = styled(Box)(({ theme }) => {
  const isDarkMode = theme.palette.mode === "dark";

  return {
    display: "flex",
    width: "100%",
    gap: theme.spacing(2),
    padding: "8px 0 8px 0",
    zIndex: 10000,
    backgroundColor: isDarkMode ? THEME_COLORS.DARK.SECONDARY_BG : THEME_COLORS.LIGHT.SECONDARY_BG,
    justifyContent: "flex-end",
    "& button": {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0,
      maxWidth: "100px",
      minWidth: 0
    }
  };
});

const TriggerPropertiesButtons = ({ onSubmit, onCancel, submitting, disableSubmit }) => {
  const { t } = useTranslation("flowDesigner");

  return (
    <ButtonsWrapper>
      <SoftButton variant="outlined" color="info" onClick={onCancel}>
        {t("buttons.cancel")}
      </SoftButton>

      <SoftButton color="primary" variant="contained" disabled={submitting || disableSubmit} onClick={onSubmit}>
        {t("buttons.save")}
      </SoftButton>
    </ButtonsWrapper>
  );
};

export default TriggerPropertiesButtons;
